export enum TRulerOption {
  NONE = "none",
  LINE = "line",
  CROSS = "cross",
  CIRCLE = "circle",
}
